import { render, staticRenderFns } from "./filtering.vue?vue&type=template&id=01a4d670&"
import script from "./filtering.vue?vue&type=script&lang=js&"
export * from "./filtering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports